import { render, staticRenderFns } from "./TheSecondaryMenu.vue?vue&type=template&id=6b07987a&scoped=true"
import script from "./TheSecondaryMenu.vue?vue&type=script&lang=js"
export * from "./TheSecondaryMenu.vue?vue&type=script&lang=js"
import style0 from "./TheSecondaryMenu.vue?vue&type=style&index=0&id=6b07987a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b07987a",
  null
  
)

export default component.exports